export default __webpack_public_path__ + "static/media/dive_shot7.36eecbf6.png";